import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useMovieSearchStore } from 'src/composables/useMovieSearch';


export default /*@__PURE__*/_defineComponent({
  __name: 'MovieTagSearchModal',
  setup(__props) {

const ctx = useMovieSearchStore();

return (_ctx: any,_cache: any) => {
  const _component_TagModal = _resolveComponent("TagModal")!

  return (_unref(ctx).movieSearch.showTagModal)
    ? (_openBlock(), _createBlock(_component_TagModal, {
        key: 0,
        title: "動画タグの選択",
        modelValue: _unref(ctx).movieSearch.params.tags,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(ctx).movieSearch.params.tags) = $event)),
        "allow-create-tag": false,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(ctx).onTagParamChange())),
        onDismiss: _cache[2] || (_cache[2] = ($event: any) => (_unref(ctx).movieSearch.showTagModal = false))
      }, null, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})